/**
 * Campos de Google Analytics 4 e Meta Pixel no painel Empresas.
 * @param {{
 *   ga4Id: string,
 *   pixelId: string,
 *   onGa4Change: (v: string) => void,
 *   onPixelChange: (v: string) => void,
 *   disabled?: boolean,
 * }} props
 */
export function StoreAnalyticsForm({ ga4Id, pixelId, onGa4Change, onPixelChange, disabled = false }) {
  return (
    <div className="space-y-3 rounded-xl border border-indigo-700/20 bg-indigo-500/[0.06] p-4 dark:border-indigo-400/20 dark:bg-indigo-500/[0.08]">
      <p className="text-xs font-semibold uppercase tracking-wide text-indigo-900 dark:text-indigo-200">
        Análise e remarketing (por loja)
      </p>
      <p className="text-[11px] leading-relaxed text-ink/65 dark:text-mist/65">
        Os scripts só carregam na loja pública após o visitante aceitar cookies (Consent Mode v2). Deixe vazio para
        desligar.
      </p>
      <label className="block text-sm font-semibold text-ink dark:text-mist">
        Google Analytics 4 — ID de medição
        <input
          type="text"
          inputMode="text"
          autoComplete="off"
          spellCheck={false}
          placeholder="G-XXXXXXXXXX"
          disabled={disabled}
          value={ga4Id}
          onChange={(e) => onGa4Change(e.target.value.trim())}
          className="mt-1 w-full rounded-xl border border-ink/10 bg-white px-3 py-2 font-mono text-sm dark:border-white/10 dark:bg-[#252f2a]"
        />
      </label>
      <label className="block text-sm font-semibold text-ink dark:text-mist">
        Meta Pixel — ID numérico
        <input
          type="text"
          inputMode="numeric"
          autoComplete="off"
          spellCheck={false}
          placeholder="123456789012345"
          disabled={disabled}
          value={pixelId}
          onChange={(e) => onPixelChange(e.target.value.replace(/\D/g, ''))}
          className="mt-1 w-full rounded-xl border border-ink/10 bg-white px-3 py-2 font-mono text-sm dark:border-white/10 dark:bg-[#252f2a]"
        />
      </label>
    </div>
  );
}
